module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Participants":"Participants","Mute":"Mute","Unmute":"Unmute"},"zh":{"Participants":"在线观众","Mute":"禁言","Unmute":"取消禁言"}}')
  delete Component.options._Ctor
}
